import { Pressable, Text, View } from 'react-native'
import { SheetManager, type SheetProps } from 'react-native-actions-sheet'
import { useTranslation } from 'react-i18next'

import { cn } from '@/utils/cn'

import { BottomSheet } from './BottomSheet'

export function SellerComplaintSheet(props: SheetProps<'seller-complaint'>) {
  const { t } = useTranslation()
  function handleAppeal() {
    SheetManager.hide(props.sheetId)
    // Before opening camera modal, we need to wait for SheetManager to hide the sheet
    setTimeout(() => {
      props.payload?.openAppealScreen()
    }, 300)
  }
  function handleReviseOrder() {
    SheetManager.hide(props.sheetId)
    // Before opening camera modal, we need to wait for SheetManager to hide the sheet
    setTimeout(() => {
      props.payload?.openReviseOrderScreen()
    }, 300)
  }

  return (
    <BottomSheet>
      <Pressable onPress={handleAppeal}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Text className={'text-base text-text-primary'}>{t('ui:startAppeal')}</Text>
          </View>
        )}
      </Pressable>
      <Pressable onPress={handleReviseOrder}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Text className={'text-base text-text-primary'}>{t('ui:amountMismatch')}</Text>
          </View>
        )}
      </Pressable>
      <Pressable onPress={() => SheetManager.hide(props.sheetId)}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Text className={'text-base text-text-primary'}>{t('ui:cancel')}</Text>
          </View>
        )}
      </Pressable>
    </BottomSheet>
  )
}
